<template>
  <div class="login">
    <div class="login-bg register-bg"></div>
    <main class="container consent">
      <router-link to="login">
        <img src="~@/assets/images/logo-full-mono-light.png" alt />
      </router-link>
      <h1>Research Participant Expression of Interest</h1>
      <div class="page">
        <div class="consentContainer">
          <EOI
            v-on:saveRecruimentEOI="saveRecruimentEOI"
            v-bind:showThanksResponse="showThanksResponse"
          ></EOI>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import EOI from '@/components/EOI'
import {microbaSuccess, microbaFailure, microbaLoader} from '@/services/notificationServices'

export default {
  name: 'ResearchParticipantEOI',
  components: { EOI },
  props: {
    recruitmentId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      showThanksResponse: false
    }
  },
  methods: {
    saveRecruimentEOI (payload) {
      microbaLoader.showLoader()
      this.$store
        .dispatch('postRecruitmentCandidate', Object.assign(payload, {recruitmentId: this.recruitmentId}))
        .then(response => {
          microbaSuccess({text: `Thank you, your details have been submitted.`})
          this.showThanksResponse = true
        })
        .catch(error => {
          let errorText = `Failed to save response, please try again.`
          if (error.response.status === 400) {
            errorText = `Your email has been used to express interest in this study already. 
            Please check your inbox for further instructions on study screening and eligibility.`
          }
          microbaFailure({
            text: errorText
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.consent {
  .page {
    padding: 1.75rem 1.5rem 0rem 1.5rem;
    background: #ffffff;
    border-radius: 0.3rem;
    .consentContainer {
      min-height: 500px;
      font-size: 1rem;
      .consentText {
        font-size: 1rem;
        padding: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/application/research/ResearchParticipantEOI.vue